define('datakit/lib/abstract.has.many.relationship.type',['require','exports','module','backbone','./abstract.has.one.relationship.type'],function(require, exports, module) {
  var Backbone             = require('backbone');
  var AbstractHasOneRelationshipType = require('./abstract.has.one.relationship.type');;


  var AbstractHasManyRelationshipType = AbstractHasOneRelationshipType.extend({
    supportedResourceClass: Backbone.Collection
  });

  module.exports = AbstractHasManyRelationshipType;
});
